
import { Component, Vue } from 'vue-property-decorator';
import DialogImgLarge from '@/components/ImgLarge/index.vue';
import { createQuoteOrder } from '@/api/orderService';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'orderServicerToquote',
  components: {
    DialogImgLarge
  }
})
export default class extends Vue {
  private formQuote: any = {

  }
  private qiuniuToken:any = {}

  private selectParts: any = []
  private dynamicCost: any = []
  private pictureList: any= []

  private detail:any={}
  created() {
    this.detail = JSON.parse(this.$route.query.detail as string);
    this.selectParts = this.detail.order.parts_list;
    this.pictureList = this.detail.order.order_image;
    this.dynamicCost = this.detail.order.order_price;
  }

  private imgLargeHandle(val: any, index: number) {
    let src = [];
    for (let i = 0; i < val.length; i++) {
      src.push(val[i].img_url);
    }
    let enlargedData = {
      isShow: true,
      imgList: src,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  private onSave() {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.order_id = this.detail.order.id;
    pamars.order_service_id = this.detail.order_service.id;
    createQuoteOrder(pamars).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.$router.go(-1);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
